module.exports = __webpack_public_path__ + "static/media/item_24_2.58dc2e08.png";